import Vue from 'vue';
import Router from 'vue-router';

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router);

export const constantRoutes = [
	{
		path: '/',
		redirect: '/index'
	}, {
		name: 'index',
		path: '/index',
		component: () => import('@/views/index/index'),
		meta:{ title: '首页', keepAlive: false }
	}
]

const createRouter = () => new Router({
	mode: 'history',
	routes: constantRoutes,
	scrollBehavior(to, from, savePosition) {
		if (savePosition) {
			return savePosition
		} else {
			return {
				x: 0,
				y: 0
			}
		}
	}
})
const router = createRouter();

// 路由守卫
router.beforeEach((to,from ,next)=>{
	document.title = to.meta.title? to.meta.title: 'halohalo';
	next()
})

export default router
